import { render, staticRenderFns } from "./ListaCotacao.vue?vue&type=template&id=85513938"
import script from "./ListaCotacao.vue?vue&type=script&lang=js"
export * from "./ListaCotacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports